<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col sm="12">
                <b-card  header-tag="header" footer-tag="footer">
                  <div slot="header">
                <strong>GatePass</strong>
                <div class="card-header-actions">
                </div>
              </div>
                    <b-row>
                        <b-col md="12">
                            <div>
                                <ul class="nav nav-tabs nav-justified">
                                    <li class="nav-item">
                                        <a @click="activeTab = 0"  class="nav-link " :class="{'active' : isActiveTab(0)}">Entry Gate Pass</a>
                                    </li>
                                    <li class="nav-item">
                                        <a @click="activeTab = 1"  class="nav-link " :class="{'active' : isActiveTab(1)}">Exit Gate Pass</a>
                                    </li>
                                </ul>
                            </div>
                        </b-col>
  
                        <b-col md="12">
                            <div class="tab-panel"  v-if="isActiveTab(0)">
                                <gate_entry_pass></gate_entry_pass>

                            </div>
                             <div class="tab-panel" v-if="isActiveTab(1)">
                                <gate_exit_pass></gate_exit_pass>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
  </template>
  
  <script>
  import CONSTANTS from "@/utils/constants";
  import Utils from "@/utils";
  import gate_exit_pass from '../components/gate_exit_pass'
  import gate_entry_pass from '../components/gate_entry_pass'

  export default {
  data() {
      return {
          activeTab: 0,
          gate_exit_pass,
          gate_entry_pass
      }
  },
  components : {
        gate_exit_pass,
        gate_entry_pass,
  },
  methods: {
    isActiveTab(id)
      {
      return this.activeTab === id
      }
  }
}
  </script>
<style scoped>
.nav-tabs .nav-link.active {
    color: #2f353a;
    background: #20a8d8 !important;
    border-color: #c8ced3;
    border-bottom-color: #fff;
    border-radius: 10px !important;
    border-bottom: none !important;
}
.nav-tabs .nav-link {
    color: #2f353a;
    border-color: #c8ced3;
    border-bottom-color: #fff;
    border-radius: 10px !important;
    border-bottom: none !important;
}

/* .nav .nav-tabs .nav-justified {
    border-bottom: none !important;
}

.nav-tabs {
    border-bottom: none !important;
} */
</style>